import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getRegulationsStaffRolesInfo(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAFF_ROLES_INFO,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAFF_ROLES_INFO].GET_REGULATIONS_STAFF_ROLES_INFO,
		options
	)
}
export default {
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAFF_ROLES_INFO].GET_REGULATIONS_STAFF_ROLES_INFO]: _getRegulationsStaffRolesInfo,
}